export {
  PRIMARY_NAVIGATION_BAR_BASE_ROW_HEIGHT,
  PRIMARY_NAVIGATION_STRIP_ICON_HIT_TARGET_PX,
  PRIMARY_NAVIGATION_STRIP_ICON_VERTICAL_INSET_PX,
} from "#primary-navigation-strip";
